import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import {
  hasNonZeroDashboardValues,
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import type { PatientsAgeOverviewState } from '@hooks/dashboard/usePatientsAge'
import { OperationsPatientsAgeChart } from '../OperationsPatientsCharts.component'

type PatientsAgeCardProps = {
  titleHref: string
  chartData: PatientsAgeOverviewState['chartData']
  axis: PatientsAgeOverviewState['axis']
  loading: boolean
  hasPayload: boolean
}

export function PatientsAgeCard({
  titleHref,
  chartData,
  axis,
  loading,
  hasPayload,
}: PatientsAgeCardProps): React.ReactElement {
  const hasData = chartData.some((point) =>
    hasNonZeroDashboardValues(point.Male, point.Female),
  )
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Patients age"
      titleHref={titleHref}
      className="dashboard-operations-patients-card"
      loading={pending}
      skeleton={{ block: 'chart' }}
      isEmpty={isEmpty}
    >
      <OperationsPatientsAgeChart data={chartData} axis={axis} />
    </DashboardSectionCard>
  )
}
